module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/global/language-picker/language-picker.component.scss
// module id = ./client/app/global/language-picker/language-picker.component.scss
// module chunks = main